import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../_services/admin.service';
import { HeaderData } from 'src/app/_models/header-data';
import { PageCriteria } from 'src/app/_models/page-criteria';
import { UserStatusID, CompanyStatusID, StatusCode } from '../../../_common/_enum/module.enum'; //USING IT IN HTML
import { BehaviorSubject } from 'rxjs';
import { PROFILE_OPTIONS, RESULTS_NOT_FOUND } from 'src/app/_common/product-config';

export enum ViewEnum {
  Details = "Details",
  Users = "Users"
}


@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})
export class CompanyDetailsComponent implements OnInit {

  resultsNotFound = RESULTS_NOT_FOUND;
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private loading: boolean = false;
  private companyDetails;
  private companyID = null;
  private companyUsers = null;
  private userCriteria: PageCriteria;
  private _total$ = new BehaviorSubject<number>(0);
  private userLoading: boolean = false;
  
  private resendActivationLoader = [];
  private sentActivationLoader = [];
  private failedActivationLoader = [];

  private selectedItem = ViewEnum.Details;
  private filterObj: Object[];
  private selectedStatus: any;
  private hasAccess:boolean = false;
  private newBusinessError:string;
  private endtError:string;
  private renewalError:string;
  private closeNBAlert:boolean = false;
  private closeEndtAlert:boolean = false;
  private closeRenewalAlert:boolean = false;

  constructor(private readonly route: ActivatedRoute, private router: Router, private adminService: AdminService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    if(history && history.state){
      if(history.state.newBusinessError){

        this.newBusinessError = "New Business Permission(s) Not Added: " + history.state.newBusinessError;
      }
      if(history.state.endtError){
        this.endtError = "Endorsement Permission(s) Not Added: "  + history.state.endtError;
      }
      if(history.state.renewalError){
        this.renewalError = "Renewal Permission Not Added: "  + history.state.renewalError;
      }
    }
    //Getting Okta ID for State params
    this.route.paramMap.subscribe(params => {
      this.companyID = params.get("id").toString();
      this.fetchCompanyDetails();
    });
    
    this.filterObj = [
      {filterIndex: 0, displayName : 'All', value: null, group: 'UserStatus'},
      {filterIndex: 1, displayName : 'Active', value: '1', group: 'UserStatus'},
      {filterIndex: 2, displayName : 'Deactivated', value: '2', group: 'UserStatus'},
      /*{filterIndex: 3, displayName : 'On Hold', value: '3', group: 'UserStatus'},*/
      {filterIndex: 4, displayName : 'Pending Activation', value: '4', group: 'UserStatus'},
      /*{filterIndex: 5, displayName : 'Expired', value: '5', group: 'UserStatus'},
      {filterIndex: 6, displayName : 'Reset', value: '6', group: 'UserStatus'},*/
    ];
    this.selectedStatus = this.filterObj.find((obj:any) => {return obj.group == 'UserStatus' && obj.displayName == 'All'});
  }
  setHeaderData(){
    this.headerData.pageTitle = (this.companyDetails)?(this.companyDetails.companyName):"";
    this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];
    if(this.companyDetails){
      this.headerData.breadcrumb.push({itemName: "Companies", itemLink: "/admin/companies"})
    }
    this.adminService.header = this.headerData;  
  }

  get CompanyViewEnum(){
    return ViewEnum;
  }
  
  get UserStatusIDEnum(){
    return UserStatusID;
  }
  
  get CompanyStatusIDEnum(){
    return CompanyStatusID;
  }
  

  get allProfileOptions(){
    return PROFILE_OPTIONS;
  }

  fetchCompanyDetails(){
    this.loading = true;
    let companyDetailsSubscription = this.adminService.fetchCompanyDetails(this.companyID).subscribe((company:any)=>{
      this.hasAccess = true;
      this.companyDetails = company;
      if(this.companyDetails != null){
        this.setHeaderData();
        let producerCodes = this.companyDetails.producerCodes;//.split(",").map(Number);
        
        let newProducerCodes = [];
        producerCodes.forEach(_producerCode => {
          newProducerCodes.push({code: _producerCode, isSelected: true});
        });
        
        this.companyDetails.producerCodesArray = newProducerCodes;
        this.companyDetails.permissions = company.permissions;
        this.getCompanyConfig();
      }
    },error=>{
      this.loading = false;
      this.companyDetails = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.adminService.runningServices.push(companyDetailsSubscription);
  }
  getCompanyConfig(){
    this.loading = true;
    let companyConfigSubscription = this.adminService.getCompanyConfig().subscribe(response => {
      this.loading = false;
      if(response) {
        let permList = [];
        response.companyPermissions.forEach(p => {
          let permMatch = this.companyDetails.permissions.find((perm) => perm.moduleName == p.moduleName);
          if(permMatch)
          {
            p.isSelected = permMatch.isSelected;
          }
          permList.push(p);
        });
        this.companyDetails.permissions = permList;
      }
    },
    error => {
      this.loading = false;
      this.companyDetails = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.adminService.runningServices.push(companyConfigSubscription);
  }

  showCompanyDetails(){
    this.selectedItem = this.CompanyViewEnum.Details;
  }
  showCompanyUsers(){
    this.selectedItem = this.CompanyViewEnum.Users;

    if(!this.companyUsers){
      this.filterUsers();
    }
  }
  filterUsers(item = null, type = null){
    if(type == this.selectedStatus.group){
      this.selectedStatus = item;
    }
    this.userCriteria = new PageCriteria();
    this.userCriteria.filterBy = [];
    if(this.companyDetails && this.companyDetails.companyID != null){
      this.userCriteria.filterBy.push({
        "FilterColumnName": "CompanyID",
        "FilterValue": this.companyDetails.companyID
      });
    }else{
      this.userCriteria.filterBy.push({
        "FilterColumnName": "CompanyID",
        "FilterValue": this.companyID
      });
    }
    if(this.selectedStatus && this.selectedStatus.value != null){
      this.userCriteria.filterBy.push({
        "FilterColumnName": "StatusID",
        "FilterValue": this.selectedStatus.value
      });
    }

    this.userCriteria.sortBy = "FirstName";
    this.userCriteria.sortOrder = "asc";
    this.userCriteria.pageNo = 1;
    this.fetchUsers();
  }
  fetchUsers(){
    this.userLoading = true;
    let fetchUsersSubscription = this.adminService.fetchUsers(this.userCriteria).subscribe((users:any) => {
      this.userLoading = false;
      this._total$.next(users.length);
      this.companyUsers = users;
      console.log(this._total$);
    },error=>{
      this.userLoading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.adminService.runningServices.push(fetchUsersSubscription);
  }
  get total$() { return this._total$.asObservable(); }
  
  getUserStatusClass(status){
    return (status.toLowerCase() === "pending activation")?"pending-activation":(status.toLowerCase() === "on hold")?"on-hold":status.toLowerCase();
  }
  resendActivationEmail(_user){
    if(_user.statusID == UserStatusID.PendingActivation){
      this.resendActivationLoader.push(_user.emailID);
      this.adminService.resendActivationEmail(_user.emailID).subscribe(data=>{
        this.resendActivationLoader.splice(this.resendActivationLoader.indexOf(_user.emailID),1);
        if(data){
          this.sentActivationLoader.push(_user.emailID);
        }else{
          this.failedActivationLoader.push(_user.emailID);
        }
        setTimeout(()=>{
          this.sentActivationLoader.splice(this.sentActivationLoader.indexOf(_user.emailID),1);
          this.failedActivationLoader.splice(this.failedActivationLoader.indexOf(_user.emailID),1);
        }, 3000);
      },
      error => {
        this.resendActivationLoader.splice(this.resendActivationLoader.indexOf(_user.emailID),1);
        console.log("Resend Activation email Error : "+ error);
      });
    }
  }

  goToEditCompany(){
    this.router.navigateByUrl("admin/company/" + this.companyID + "/edit");
  }

  goToAddUsers(){
    this.router.navigate(['/admin/user/new'], {state: {companyID: this.companyID}});//ByUrl("admin/user/new");
  }
  
  onPageChange(){
    window.scrollTo(0, 0);
  }
  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }

}
